import { LOGO_URL } from "@/lib/brand";

const dots = [
  { top: "18%", left: "12%", delay: "0s" },
  { top: "62%", left: "8%", delay: "1.5s" },
  { top: "30%", left: "88%", delay: "0.8s" },
  { top: "75%", left: "80%", delay: "2.4s" },
  { top: "12%", left: "60%", delay: "3.1s" },
];

export const Hero = () => (
  <section id="top" className="relative overflow-hidden" data-testid="hero-section">
    {dots.map((d, i) => (
      <span key={i} className="firefly-dot" style={{ top: d.top, left: d.left, animationDelay: d.delay }} />
    ))}
    <div className="max-w-6xl mx-auto px-6 pt-16 pb-28 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7 order-2 lg:order-1">
        <p className="rise text-xs uppercase tracking-[0.35em] text-amber-800 font-semibold mb-6">Monthly happy mail · India</p>
        <h1 className="rise font-serif-display text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.1] text-stone-900" style={{ animationDelay: "0.1s" }} data-testid="hero-tagline">
          A little more hope for a world that could <em className="text-amber-700">use some.</em>
        </h1>
        <p className="rise font-hand text-3xl text-stone-700 mt-8 -rotate-1" style={{ animationDelay: "0.25s" }}>
          A little light, delivered monthly.
        </p>
        <div className="rise flex flex-wrap gap-4 mt-12" style={{ animationDelay: "0.4s" }}>
          <a href="#pricing" className="rounded-full bg-stone-900 text-white px-7 py-3.5 hover:bg-amber-600 hover:-translate-y-0.5 transition-[background-color,transform] duration-300" data-testid="hero-join-button">
            Choose your plan · from ₹444 onwards
          </a>
          <a href="#whats-inside" className="rounded-full border border-stone-300 px-7 py-3.5 text-stone-800 hover:border-amber-500 hover:bg-amber-50 transition-colors duration-300" data-testid="hero-inside-button">
            What's inside
          </a>
        </div>
      </div>
      <div className="lg:col-span-5 order-1 lg:order-2 relative flex justify-center">
        <div className="lantern-glow absolute w-[26rem] h-[26rem] rounded-full -top-6" />
        <img src={LOGO_URL} alt="The Little Lantern Club logo" className="relative h-80 sm:h-[26rem] w-auto object-contain rise" data-testid="hero-logo" />
      </div>
    </div>
  </section>
);
